// Stripe Payment Element and confirmPayment need ISO 3166 alpha-2 country codes.
// The HLI country field stores ISO3166 common names from Constants::GetCountries.

export function isoCountryCode(countryName, nameToIso = {}) {
  if (!countryName) return undefined
  return nameToIso[countryName] || undefined
}

export function stripeBillingDetails({ firstName, lastName, email, address = {}, nameToIso = {} } = {}) {
  const name = [firstName, lastName].filter(Boolean).join(" ")
  const billing = {}
  if (name) billing.name = name
  if (email) billing.email = email

  const compactAddress = Object.fromEntries(
    Object.entries({
      line1: address.line1,
      line2: address.line2,
      city: address.city,
      state: address.state,
      postal_code: address.postal_code,
      country: isoCountryCode(address.country, nameToIso)
    }).filter(([, value]) => value)
  )
  if (Object.keys(compactAddress).length) billing.address = compactAddress
  return billing
}
